import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.slider = this.$('slider')
        this.prev = this.$('prev')
        this.next = this.$('next')
    }

    init() {

        const args = {
            speed: 800,
            loop: true,
            loopedSlides: 2,
            spaceBetween: 200,
            grabCursor: true,
            slideToClickedSlide: true,
            breakpoints: {
                1200: {
                    spaceBetween: 100
                },
                700: {
                    spaceBetween: 40
                }
            },
            navigation: {
                nextEl: this.next,
                prevEl: this.prev
            }
        }

        this.carousel = new Swiper(this.slider, args)
    }

    destroy() {
        this.carousel.destroy()
    }
}
